// Core
import React, { useState } from "react";

// Contrib
import { Grid, Row, Col, ButtonGroup, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParams, Link } from "react-router-dom";

function Questions(props) {
   let { alphaheader } = useParams();
   var data = props.data.data.find((item) => item.AlphaHeaderText == alphaheader.replace(/-+/g, " "));

   var date = new Date(data.Date);

   var icon = "";
   switch (data.AlphaHeaderText) {
      case "General":
         icon = "question-circle";
         break;
      case "Accessibility":
         icon = "universal-access";
         break;
      case "Agenda":
         icon = "calendar";
         break;
      case "Live Events & Presentations":
         icon = "person-chalkboard";
         break;
      case "Networking":
         icon = "network-wired";
         break;
      case "1:1 Meet the Experts":
         icon = "handshake";
         break;
      case "Registration & Attendance":
         icon = "address-card";
         break;
      case "Resources":
         icon = "circle-info";
         break;
      case "vFairs Virtual Platform":
         icon = "display";
         break;
   }

   return (
      <>
         <div className="greenHeader headerBg">
            <h1>{props.data.Category_name}</h1>
            <h2>
               <strong>FAQs</strong>
            </h2>
         </div>
         <Grid>
            <Row>
               <Col md={3} className="text-center">
                  <FontAwesomeIcon icon={icon} size="4x" />
                  <p className="itemTitle h3 text-center">
                     <strong>{data.AlphaHeaderText}</strong>
                  </p>
                  Last Update: {date.getMonth() + "/" + date.getDate() + "/" + date.getFullYear()}
               </Col>
               <Col md={9}>
                  <Link to={"/"} className="text-primary" style={{ marginBottom: "30px", display: "block" }}>
                     Back to <strong>All FAQs</strong>
                  </Link>
                  <div className="itemsView list">
                     {data.headers[0].questions.map((item, i) => (
                        <Link to={"/" + data.AlphaHeaderText.replace(/\s+/g, "-") + "/" + item.Question.replace(/\s+/g, "-")} key={item.ID}>
                           <strong>{i + 1 + ". " + item.Question}</strong>
                           <FontAwesomeIcon icon="arrow-right" style={{ fontSize: "2em", color: "#000" }} />
                        </Link>
                     ))}
                  </div>
               </Col>
            </Row>
         </Grid>
      </>
   );
}

export default Questions;
